import React, { useMemo } from "react";
import { useUserContext } from "../../utils/UserContext";
import { formatAddress } from "../../utils/Utilitats";
import LlistaRecursos from "./LlistaRecursos";
import { ChipActiu, MiniaturaRecurs } from "./RecursosComuns";

export const idMagatzem = (m) => (m ? Number(m.idMagatzems) : null);
const esActiu = (m) => Number(m.Actiu) === 1;
const text = (valor) => valor || "—";
const adreca = (m) => formatAddress(m);

const COLUMNES = [
  {
    key: "Imatge",
    label: "",
    senseOrdre: true,
    render: (m) => <MiniaturaRecurs imatge={m.Imatge} alt={m.Nom} icona="🏭" />,
  },
  { key: "Nom", label: "Nom", render: (m) => <strong>{m.Nom}</strong> },
  { key: "Codi", label: "Codi", render: (m) => text(m.Codi) },
  { key: "EmpresaNom", label: "Empresa", render: (m) => text(m.EmpresaNom) },
  { key: "NomVia", label: "Adreça", sortValue: adreca, render: (m) => text(adreca(m)) },
  { key: "ResponsableNom", label: "Responsable", render: (m) => text(m.ResponsableNom) },
  {
    key: "Telefon",
    label: "Telèfon",
    render: (m) =>
      m.Telefon ? (
        <a href={`tel:${m.Telefon.replace(/[^\d+]/g, "")}`} onClick={(e) => e.stopPropagation()}>
          {m.Telefon}
        </a>
      ) : (
        "—"
      ),
  },
  { key: "Actiu", label: "Estat", sortValue: (m) => (esActiu(m) ? 0 : 1), render: (m) => <ChipActiu actiu={esActiu(m)} /> },
];

const textCerca = (m) => [m.Nom, m.Codi, m.Telefon, m.Email].filter(Boolean).join(" ");

const renderTargeta = (m) => ({
  imatge: <MiniaturaRecurs imatge={m.Imatge} alt={m.Nom} icona="🏭" />,
  titol: [m.Nom, m.Codi && `(${m.Codi})`].filter(Boolean).join(" "),
  meta: [m.Poblacio, m.ResponsableNom, esActiu(m) ? null : "Inactiu"].filter(Boolean).join(" · "),
});

const ORDRE_INICIAL = { key: "Nom", direction: "asc" };

function Seleccionarmagatzem(props) {
  const { empresaSeleccionada } = useUserContext();
  const cosPeticio = useMemo(
    () => ({ idEmpresa: empresaSeleccionada?.IdEmpresa || null }),
    [empresaSeleccionada]
  );

  return (
    <LlistaRecursos
      {...props}
      endpoint="Magatzems.php"
      clauDades="magatzems"
      cosPeticio={cosPeticio}
      idDe={idMagatzem}
      esActiu={esActiu}
      columnes={COLUMNES}
      textCerca={textCerca}
      renderTargeta={renderTargeta}
      placeholderCerca="Cerca per nom, codi, telèfon o email…"
      etiquetaPlural="magatzems"
      ordreInicial={ORDRE_INICIAL}
    />
  );
}

export default Seleccionarmagatzem;
